import { AbstractControl, ValidationErrors } from '@angular/forms';

export function rxRequiredValidator(control: AbstractControl): ValidationErrors | null {
  return control.value === null ||
    (typeof control.value === 'string' && control.value.trim() === '')
    ? { required: true }
    : null;
}
